import { ReactNode } from 'react';
import { FieldError } from 'react-hook-form';
import { ErrorMessage } from './ErrorMessage';
import { SubmitButton } from './SubmitButton';
import classNames from 'classnames';

export interface FormProps {
  onSubmit?(): void;

  className?: string;
  children: JSX.Element | JSX.Element[] | ReactNode;
  globalError?: FieldError;
  submitButton?: () => ReactNode;
}

export function Form({
  onSubmit,
  children,
  globalError,
  submitButton,
  className,
}: FormProps) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit && onSubmit();
      }}
    >
      <div
        className={classNames(
          'space-y-6 sm:space-y-5 divide-gray-200',
          className
        )}
      >
        {children}
        {globalError ? (
          <div className="flex justify-center mb-1 h-[30px]">
            <ErrorMessage error={globalError} />
          </div>
        ) : null}
        <div className="flex justify-end">
          {submitButton ? submitButton() : <SubmitButton>Submit</SubmitButton>}
        </div>
      </div>
    </form>
  );
}
